/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'elasticSearchOverlay.title',
    defaultMessage: 'Elasticsearch'
  },
  close: {
    id: 'elasticSearchOverlay.close',
    defaultMessage: 'Close'
  },
  finish: {
    id: 'elasticSearchOverlay.finish',
    defaultMessage: 'Finish'
  },
  save: {
    id: 'elasticSearchOverlay.save',
    defaultMessage: 'Save'
  },
  next: {
    id: 'elasticSearchOverlay.next',
    defaultMessage: 'Next'
  },
  cancel: {
    id: 'elasticSearchOverlay.cancel',
    defaultMessage: 'Cancel'
  },
  connect: {
    id: 'elasticSearchOverlay.connect',
    defaultMessage: 'Connect Elasticsearch'
  },
  index: {
    id: 'elasticSearchOverlay.index',
    defaultMessage: 'Select index'
  },
  search: {
    id: 'elasticSearchOverlay.search',
    defaultMessage: 'Conversational search (optional)'
  },
  resultContent: {
    id: 'elasticSearchOverlay.resultContent',
    defaultMessage: 'Configure result content'
  }
});
